import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Module } from 'projects/access-control/src/app/Domain/Entities/module.interface';
import { Client } from 'projects/access-control/src/app/Domain/Entities/client.interface';
import { IDomain } from 'projects/access-control/src/app/Domain/Entities/domain.interface';
import { ModuleClient } from 'projects/access-control/src/app/Domain/Entities/module-client.interface';
import { postModuleClient } from 'projects/access-control/src/app/Infrastructure/Store/clients/clients.action';
import { getAllModule } from 'projects/access-control/src/app/Infrastructure/Store/systems-module/systems-module.action';
import { selectModuleState } from 'projects/access-control/src/app/Infrastructure/Store/systems-module/systems-module.selectors';
import { TranslateService } from '@mangosoft/mango-layout';
import { select, Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { domains } from './domains';

interface translateModalModuleClient {
	title: string;
	name: string;
	placeholderName: string;
	nameRequired: string;
	systemModule: string;
	placeholderSystemModule: string;
	placeholderSelectDomain: string;
	selectDomain: string;
	domainRequired: string;
	systemRequired: string;
	textCustomDomains: string;
	mainDomain: string;
	placeholderMainDomain: string;
	subDomain: string;
	placeholderSubDomain: string;
	buttonSave: string;
	buttonCancel: string;
}

@Component({
	selector: 'app-modal-add-module-client',
	templateUrl: './modal-add-module-client.component.html',
	styleUrls: ['./modal-add-module-client.component.scss'],
})
export class ModalAddModuleClientComponent implements OnInit, OnDestroy {
	client: Client = {} as Client;
	systemsModules: Module[] = [];
	systemsModule: Module = {} as Module;
	domains: IDomain[] = domains;
	domain: IDomain = {} as IDomain;
	subscriptionModule!: Subscription;
	formModule!: FormGroup;
	itemEdit = [];
	translateModal: translateModalModuleClient = {} as translateModalModuleClient;
	subscriptionTranslate!: Subscription;
	constructor(
		private store: Store,
		private formBuilder: FormBuilder,
		public dialogRef: MatDialogRef<ModalAddModuleClientComponent>,
		@Inject(MAT_DIALOG_DATA) public data: Client = {} as Client,
		private translate: TranslateService
	) {}

	ngOnInit(): void {
		this.formModule = this.formBuilder.group({
			name: ['', [Validators.required]],
			module: ['', [Validators.required]],
			domain: ['', [Validators.required]],
			mainDomain: ['', []],
			subDomain: ['', []],
		});
		setTimeout(() => {
			this.client = this.data;
			this.store.dispatch(getAllModule());
			this.getModules();
			this.dataTranslate();
		});
	}
	onNoClick(): void {
		this.dialogRef.close();
	}
	get f() {
		return this.formModule.controls;
	}
	getModules() {
		this.subscriptionModule = this.store
			.pipe(select(selectModuleState))
			.subscribe(({ modules }) => {
				this.systemsModules = modules;
			});
	}
	createClient() {
		if (!this.formModule.invalid) {
			const { module,domain, name, ...dataClient } = this.formModule.value;
			const moduleData: ModuleClient = {
				...dataClient,
				name: module.name,
				pk: module.pk,
				sk: module.sk,
				domain:domain.name,
				custom_name_module: name,
			} as ModuleClient;
			this.store.dispatch(
				postModuleClient({ params: { pk: this.data.pk, sk: this.data.sk }, module: moduleData })
			);
			this.onNoClick();
		}
	}

	dataTranslate() {
		this.subscriptionTranslate = this.translate.init('AccessControl').subscribe((data) => {
			this.translateModal = data.pages.clients.modalModules;
		});
	}
	ngOnDestroy(): void {
		this.subscriptionModule?.unsubscribe();
		this.subscriptionTranslate?.unsubscribe();
	}
}
